import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "74.814",
  height: "87.533",
  viewBox: "0 0 74.814 87.533"
}
const _hoisted_2 = {
  id: "disease-coverage-1-jibing",
  transform: "translate(0 0.001)"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]

import { withDefaults } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'svg-disease-coverage-1',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        id: "disease-coverage-1-路径_5609",
        "data-name": "路径 5609",
        d: "M394.19,204.171h-3.37a10.693,10.693,0,0,0-21.081,0h-5.185a2.62,2.62,0,0,0-2.621,2.621v7.3a3.116,3.116,0,0,0,3.116,3.116H393.7a3.116,3.116,0,0,0,3.116-3.116v-7.3a2.631,2.631,0,0,0-2.628-2.621Zm-13.91,6.973a5.164,5.164,0,1,1,5.164-5.164A5.162,5.162,0,0,1,380.28,211.144Z",
        transform: "translate(-346.2 -195.277)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        id: "disease-coverage-1-路径_5610",
        "data-name": "路径 5610",
        d: "M598.363,612.566l-2.755-3.419a15.072,15.072,0,1,0-5.878,4.585l2.833,3.511a3.725,3.725,0,1,0,5.8-4.677ZM576.08,599.927a7.616,7.616,0,1,1,7.616,7.616A7.628,7.628,0,0,1,576.08,599.927Z",
        transform: "translate(-524.374 -531.102)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        id: "disease-coverage-1-路径_5611",
        "data-name": "路径 5611",
        d: "M306.187,293.53h-4.528v8.958a3.116,3.116,0,0,1-3.116,3.116H263.615a3.116,3.116,0,0,1-3.116-3.116V293.53h-4.528a8.062,8.062,0,0,0-8.061,8.061v54.123a8.062,8.062,0,0,0,8.061,8.061h39.386a19.114,19.114,0,0,1,18.891-32.759V301.59A8.062,8.062,0,0,0,306.187,293.53ZM291.415,328.2h-6.471v6.471a3.73,3.73,0,1,1-7.46,0V328.2h-6.471a3.73,3.73,0,0,1,0-7.46h6.471v-6.471a3.73,3.73,0,0,1,7.46,0v6.471h6.471a3.73,3.73,0,1,1,0,7.46Z",
        transform: "translate(-247.91 -279.973)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})